import {
  AgentFeature,
  isFeatureEnabledForLanguage
} from '../../../../components/agent-features'
import { AgentLanguage } from '../../../../components/agent-language'

export type UsageCellState =
  | 'counts-not-supported'
  | 'counts-supported'
  | 'counts-and-observations-supported'

type GetUsageCellStateFn = (props: {
  readonly agentFeatures: AgentFeature[]
  readonly applicationLanguage: AgentLanguage
  readonly forApplicationLibrariesGrid: boolean
}) => UsageCellState

export const isStateCountsNotSupported = ({
  agentFeatures,
  language
}: {
  readonly agentFeatures: AgentFeature[]
  readonly language: AgentLanguage
}) =>
  !isFeatureEnabledForLanguage({
    agentFeatures,
    featureName: 'library-usage-counts',
    language
  })

export const isStateCountsAndObservationsSupported = ({
  forApplicationLibrariesGrid,
  agentFeatures,
  language
}) =>
  isFeatureEnabledForLanguage({
    agentFeatures,
    featureName: 'library-usage-observations',
    language
  }) && forApplicationLibrariesGrid === true

export const getUsageCellState: GetUsageCellStateFn = ({
  agentFeatures,
  applicationLanguage: language,
  forApplicationLibrariesGrid
}: {
  readonly agentFeatures: AgentFeature[]
  readonly applicationLanguage: AgentLanguage
  readonly forApplicationLibrariesGrid: boolean
}) => {
  if (isStateCountsNotSupported({ agentFeatures, language })) {
    return 'counts-not-supported'
  }
  if (
    isStateCountsAndObservationsSupported({
      agentFeatures,
      language,
      forApplicationLibrariesGrid
    })
  ) {
    return 'counts-and-observations-supported'
  }

  return 'counts-supported'
}
